module.exports = __webpack_public_path__ + "static/media/ar.46ca0421.svg";